import { render, staticRenderFns } from "./PropertyViewGlobal.vue?vue&type=template&id=6ad6a496&scoped=true"
import script from "./PropertyViewGlobal.vue?vue&type=script&lang=js"
export * from "./PropertyViewGlobal.vue?vue&type=script&lang=js"
import style0 from "./PropertyViewGlobal.vue?vue&type=style&index=0&id=6ad6a496&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad6a496",
  null
  
)

export default component.exports